import Vue from 'vue'
import VueRouter from 'vue-router'
import {isMobileUA, isMobileView} from 'mdetect'
import MHome from './views/MHome.vue'
import En from './views/En.vue'
import Home from './views/Home.vue'
import Video from './views/Video.vue'
import Intro from './views/Intro.vue'
import News from './views/News.vue'
import Entry from './views/Entry.vue'
import Observer from './views/Observer.vue'
import About from './views/About.vue'
import Volunteers from './views/Volunteers.vue'
import Sandbox from './views/Sandbox.vue'

Vue.use(VueRouter)

const mb = (isMobileUA() || isMobileView()) ? MHome : Home;

export const router = new VueRouter({
  mode: 'history',
  routes: [
    {path: '/', name: 'index', component: mb},
    {path: '/en', name: 'en', component: En},
    {path: '/video', name: 'video', component: Video},
    {path: '/intro', name: 'intro', component: Intro},
    {path: '/news', name: 'news', component: News},
    {path: '/entry', name: 'entry', component: Entry},
    {path: '/observer', name: 'observer', component: Observer},
    {path: '/about', name: 'about', component: About},
    {path: '/volunteers', name: 'volunteers', component: Volunteers},
    {path: '/sandbox', name: 'Sandbox', component: Sandbox}
  ]
})



// WEBPACK FOOTER //
// ./src/router.js